import React, { useEffect, useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import LoginLeftBg from '../../assets/img/login-left-bg.jpg';
import KshemaLogo from '../../assets/img/kshema_logo.svg';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './LoginPage.css';
import { Label } from 'reactstrap';
import CenterSpinner from '../../components/CenterSpinner';
import { useMsal } from '@azure/msal-react';
import {
  keyCloarkAccessData,
  postSSOLogin,
  setLocalLogout,
} from '../../features/loginSlice';
import { STORAGE_KEY } from '../../utils/Constant';
import { toast } from 'react-toastify';
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  saveInLocalStorage,
} from '../../utils/Util';
import { useAppDispatch } from '../../store/redux-hooks';
import {
  addListener,
  callLogin,
  getRequestData,
  validateLogin,
} from './LoginPageHelper';
import { URL } from '../../utils/Config';

const LoginPage: React.FunctionComponent = () => {
  const { instance } = useMsal();
  const initialized = useRef(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const onSuccessfulLogin = (payload: any) => {
    saveInLocalStorage(STORAGE_KEY.POWERBI, payload.accessToken);

    dispatch(postSSOLogin(getRequestData(payload)))
      .unwrap()
      .then((fulfilled: any) => {
        setShowLoader(false);
        validateLogin(fulfilled, instance, dispatch);

        const params = new URLSearchParams();
        params.append('client_id', URL.KEY_CLOARK_CLIENTID);
        params.append('client_secret', URL.KEY_CLOARK_CLIENTSECRET);
        params.append('grant_type', URL.KEY_CLOARK_GRANTTYPE);
        params.append('scope', URL.KEY_CLOARK_SCOPE);
        dispatch(keyCloarkAccessData(params))
          .unwrap()
          .then((fulfilled: any) => {
            saveInLocalStorage(STORAGE_KEY.KEYCLOARK, fulfilled.access_token);
          })
          .catch((e) => {
            console.log('error-60', e);
          });
      })
      .catch(() => {
        dispatch(setLocalLogout);
        setShowLoader(false);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      addListener(instance, setShowLoader, onSuccessfulLogin);
    }
    const tokenExpire = getFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    if (STORAGE_KEY.TOKEN_EXPIRE === tokenExpire) {
      toast.success('Token has expired, Please login');
      removeFromLocalStorage(STORAGE_KEY.TOKEN_EXPIRE);
    }
  }, []);
  return (
    <Container className="p-0 m-0 login-parent">
      <Row className="p-0 m-0">
        <Col md={6} className="p-0 m-0 position-relative">
          <div className="position-relative image-parent-height">
            <Image
              src={LoginLeftBg}
              alt="img"
              className="opacity-52  image-parent w-100"
            />
            <div className="bg-overlay position-absolute top-0 start-0 w-100 image-parent-height" />
            <div className="position-absolute welcome-parent">
              <div className="text-left">
                <Label className="welcome">Welcome to</Label>
                <Label className="fieldAssist mt-n25">Field Assist !!</Label>
              </div>
              <p className="fw-normal text-start info">
                Earn attractive side-income without<br></br>
                forgoing your regular work by becoming a<br></br>
                <b>Kshema POSP.</b>
              </p>
            </div>
          </div>
        </Col>
        <Col md={6} className="p-3 m-0">
          <div className="m-5">
            <Image src={KshemaLogo} alt="img" className="logo" />
            <Form>
              <Button
                variant="success"
                size="lg"
                className="login-button"
                disabled={showLoader}
                onClick={(e: any) => callLogin(e, setShowLoader, instance)}
              >
                Login
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
      <CenterSpinner showLoader={showLoader} />
    </Container>
  );
};

export default LoginPage;
